import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_93: DocMigration = {
  maxSchemaVersion: "0.0.93",
  description: "Migrate door catalog to settings",
  apply(json: any) {
    if (json.doorCatalog) {
      const id = makeSettingsOverrideDoorCatalog(json);
      migrateDoorCatalogToSettingsOverride(json, json.doorCatalog, id);
    }
    delete json["doorCatalog"];

    for (const elevationId in json.elevations) {
      const elevation = json.elevations[elevationId];
      if (elevation.doorCatalog) {
        if (elevation.doorCatalog.length > 0) {
          const eId = makeSettingsOverrideDoorCatalog(elevation);
          migrateDoorCatalogToSettingsOverride(json, elevation.doorCatalog, eId);
        }
      }
      delete elevation["doorCatalog"];
    }
    return json;
  },
};

function makeSettingsOverrideDoorCatalog(json: any) {
  let id = uid();
  if (json.settingsOverride) {
    id = json.settingsOverride.doorCatalog ?? id;
    json.settingsOverride = {
      ...json.settingsOverride,
      doorCatalog: id,
    };
  } else {
    json.settingsOverride = { doorCatalog: id };
  }
  return id;
}

function migrateDoorCatalogToSettingsOverride(json: any, catalog, id) {
  const doorCatalog = json.settings[id] ?? {
    type: "DOOR_CATALOG_SETTINGS",
  };
  doorCatalog["doorTypes"] = { ...catalog };
  json.settings[id] = doorCatalog;

  return json;
}

export default migration_0_0_93;
